/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum RoyalMailManagementAction {
    BOOK_INBOUND = 'book_inbound',
    BOOK_OUTBOUND = 'book_outbound',
}
